import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import NodeIndexOutlinedSvg from "@ant-design/icons-svg/es/asn/NodeIndexOutlined";
import AntdIcon from "../components/AntdIcon";
var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NodeIndexOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  NodeIndexOutlined.displayName = 'NodeIndexOutlined';
}
export default /*#__PURE__*/React.forwardRef(NodeIndexOutlined);